export enum Loan {
  Home = 'Home',
  Car = 'Car',
  SMSF = 'SMSF',
  Personal = 'Personal'
}

export enum CommercialLoan {
  Commercial = 'Commercial'
}

export type LoanType = keyof typeof Loan;

export enum MpmLoan {
  Home = 'Home',
  Insurance = 'Insurance',
  Refix = 'Refix'
}
